import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";

import { register } from "../../services/AuthService";
import { Roles } from "../../utils/constants";
import HelperFormButtons from "../../components/HelperFormButtons";
import yup from "../../utils/yup";
import Form from "../../components/form/Form";

const Register = () => {
  const navigate = useNavigate();

  const registerSchema = yup
    .object()
    .shape({
      identifier: yup
        .string("The email or phone number is not valid.")
        .required("The email or phone number is required.")
        .test(
          "identifier-check",
          "The email or phone number is not valid.",
          (value) => {
            // Check for valid email
            let shouldRaiseError = false;
            if (
              !RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$").test(
                value
              )
            ) {
              shouldRaiseError = true;
            }

            // Check for valid phone number
            if (
              !RegExp(
                "^((\\+[1-9]{1,4}[ -]?)|(\\([0-9]{2,3}\\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$"
              ).test(value)
            ) {
              shouldRaiseError = true;
            }
            return shouldRaiseError;
          }
        ),
      repeat_identifier: yup
        .string("The repeat email or phone number is not valid.")
        .required("The repeat email or phone number is required.")
        .oneOf(
          [yup.ref("identifier")],
          "Your repeat email or phone number is not valid."
        ),
      password: yup
        .string("The password is not valid.")
        .required("Please enter your password.")
        .min(10, "The password must be at least 10 characters long."),
      role: yup
        .string("The role is not valid.")
        .required("Please select a role.")
        .oneOf(["EMPLOYEE", "EMPLOYER"], "The role you selected is not valid."),
    })
    .required();

  const formDetails = {
    label: "Register",
    submitButtonLabel: "Register",
    steps: [
      {
        name: "identifier",
        label: "E-mail or phone number",
        type: "text",
      },
      {
        name: "repeat_identifier",
        label: "Confirm e-mail or phone number",
        type: "text",
      },
      {
        name: "password",
        label: "Password",
        type: "text",
        htmlType: "password",
        tooltip: <Tooltip title="The password only needs to be greater than 10 characters."><InfoIcon /></Tooltip>,
      },
      {
        name: "role",
        label: "Select a role",
        type: "select",
        options: [
          { value: "", label: "Please select a role..." },
          ...Object.values(Roles)
            .filter((role) => role.value !== Roles.ADMIN.value)
            .map((role) => ({
              value: role.value,
              label: role.label,
            })),
        ],
      },
    ],
  };

  const form = useForm({
    resolver: yupResolver(registerSchema),
    mode: "onChange",
  });

  const additionalFormButtons = [
    {
      label: "Forgot password",
      route: "/reset-password",
    },
    {
      label: "Log In",
      route: "/login",
    },
  ];

  const handleSubmit = (values) => {
      register(form.setError)(values).then((data) => {
            toast.success(data.detail);
            navigate('/verification');
        });
  }

  return (
    <div>
      <Form
        formDetails={formDetails}
        form={form}
        onSubmit={handleSubmit}
      />
      <Container className="mt-2">
        <Row>
          <HelperFormButtons formButtons={additionalFormButtons} />
        </Row>
      </Container>
    </div>
  );
};

export default Register;
